module.exports = __webpack_public_path__ + "static/media/FLR_Wallpaper01_2560x1600.a050764d.jpg";